<template>
  <span
    :class="[
      'label font-weight-bold label-lg label-inline',
      status ? 'label-light-success' : 'label-light-danger'
    ]"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    /**
     * Status value (true for active, false for inactive)
     */
    status: {
      type: Number,
      required: true
    },
    /**
     * Label to display
     */
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
/* Using existing styles from the parent component */
</style>
